type ConfigEnvVars = Record<string, string | undefined>;

type BrowserLocation = {
  protocol: string;
  hostname: string;
  port?: string | number;
};

export const createConfig = (
  envVars: ConfigEnvVars = typeof process !== 'undefined'
    ? (process.env as ConfigEnvVars)
    : {},
  isBrowser = typeof window !== 'undefined',
  location: BrowserLocation | undefined = typeof window !== 'undefined'
    ? window.location
    : undefined
): AppConfig => {
  let baseUrl: string;

  if (isBrowser && location) {
    const { protocol, hostname, port } = location;
    baseUrl = `${protocol}//${hostname}${port ? `:${port}` : ''}`;
  } else {
    baseUrl = `http://localhost:${envVars.SERVER_PORT}`;
  }

  return {
    accountBaseUrl: envVars.ACCOUNT_BASE_URL,
    assetsPath: `${envVars.CLIENT_SIDE_BUCKET_PATH}/static`,
    authenticationBaseUrl: envVars.AUTHENTICATION_BASE_URL,
    authenticationEnabled: envVars.AUTHENTICATION_ENABLED === 'true',
    bannerPath: `${envVars.BANNER_BUCKET_PATH}`,
    cacheLimitInBytes: envVars.CACHE_LIMIT_IN_BYTES,
    cachePath: `${envVars.SERVER_SIDE_BUCKET_PATH}/cache`,
    cacheTTL: envVars.CACHE_TTL,
    contentPath: `${envVars.SERVER_SIDE_BUCKET_PATH}/content`,
    convoSearchPath: envVars.CONVO_SEARCH_PATH,
    cookieManagementESIEnabled:
      envVars.COOKIE_MANAGEMENT_ESI_ENABLED === 'true',
    correlationIdProp: envVars.CORRELATION_ID_PROP,
    displaySEOLinks: envVars.DISPLAY_SEO_LINKS === 'true',
    enableAPICache: envVars.ENABLE_API_CACHE === 'true',
    enableAPICacheCloning: envVars.ENABLE_API_CACHE_CLONING === 'true',
    enableGzip: envVars.ENABLE_GZIP === 'true',
    headerMinibasketActive: envVars.HEADER_MINIBASKET_ACTIVE === 'true',
    monetate: {
      url: envVars.MONETATE_API_URL,
      channel: envVars.MONETATE_CHANNEL,
    },
    myAccountUrl: envVars.MY_ACCOUNT_URL,
    peepHeader: envVars.FINDABILITY_PEEP_HEADER,
    server: { port: envVars.SERVER_PORT },
    spaCriteoEnabled: envVars.SPA_CRITEO_ENABLED === 'true',
    spaCriteoURL: envVars.SPA_CRITEO_URL,
    urls: { base: baseUrl, navigationUrl: envVars.NAVIGATION_SERVICE },
    MVO_MODE: envVars.MVO_MODE,
    HIDE_ACCOUNT_ICON: envVars.HIDE_ACCOUNT_ICON,
    HIDE_WISHLIST_ICON: envVars.HIDE_WISHLIST_ICON,
    HIDE_BASKET_ICON: envVars.HIDE_BASKET_ICON,
  };
};
